import React, { FC } from 'react';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { useNavigate, useParams } from 'react-router-dom';

interface LandscapeProjectsAddProjectsContactInformationOrganismProps {
  data: LandscapeContactPersonResponseDto[];
  handleDelete: (id: string) => void;
}

const LandscapeProjectsAddProjectsContactInformationOrganism: FC<
  LandscapeProjectsAddProjectsContactInformationOrganismProps
> = ({ data, handleDelete }) => {
  const navigate = useNavigate();

  const { id, projectId } = useParams();

  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Contact Person', key: 'name' },
        { label: 'Role', key: 'role' },
        { label: 'Email Address', key: 'emailAddress' },
      ]}
      renderRow={(row) => (
        <TableRow>
          <Label content={row.name} />
          <Label content={row.role} />
          <Label content={row.emailAddress ?? ''} />
          <Action
            type="edit"
            size="sm"
            onClick={() => {
              navigate(
                `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information/edit-contact-person/${row.id}`
              );
            }}
          ></Action>
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDelete(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default LandscapeProjectsAddProjectsContactInformationOrganism;
